import { useState } from "react";
import { supabase } from "../lib/supabase";

export function FeedbackButton({ userId }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  async function send() {
    if(!msg.trim()) return;
    setSending(true);
    const {error} = await supabase.from("feedback").insert({ user_id:userId, message:msg.trim() });
    setSending(false);
    if(error) { window.alert("No se pudo enviar el feedback. Inténtalo de nuevo."); return; }
    setDone(true);
    setTimeout(()=>{ setDone(false); setOpen(false); setMsg(""); }, 2000);
  }

  return (
    <>
      {/* Botón flotante */}
      <button onClick={()=>setOpen(true)} style={{ position:"fixed", bottom:24, right:24, background:"#fff", color:"#1a1a1a", border:"1.5px solid #1a1a1a", borderRadius:24, padding:"10px 18px", fontSize:13, fontFamily:"'Geist',sans-serif", fontWeight:600, cursor:"pointer", boxShadow:"0 4px 16px rgba(0,0,0,0.12)", zIndex:100, display:"flex", alignItems:"center", gap:8 }}>
        Feedback
      </button>

      {/* Modal */}
      {open&&(
        <div style={{ position:"fixed", bottom:80, right:24, width:320, background:"#fff", borderRadius:14, boxShadow:"0 8px 32px rgba(0,0,0,0.15)", zIndex:200, padding:20, border:"1px solid #e8e8e8" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ fontWeight:700, fontSize:15, fontFamily:"'Geist',sans-serif" }}>¿Qué piensas?</div>
            <button onClick={()=>setOpen(false)} style={{ background:"none", border:"none", cursor:"pointer", fontSize:18, color:"#aaa" }}>×</button>
          </div>
          {done ? (
            <div style={{ textAlign:"center", padding:"16px 0", color:"#16a34a", fontWeight:700 }}>✓ ¡Gracias por tu feedback!</div>
          ) : (
            <>
              <textarea autoFocus rows={4} style={{ width:"100%", border:"1px solid #e5e5e5", borderRadius:8, padding:"10px 12px", fontSize:13, fontFamily:"'Geist',sans-serif", outline:"none", resize:"none", boxSizing:"border-box", marginBottom:12 }}
                placeholder="Cuéntanos qué funciona, qué falla, o qué echarías de menos..."
                value={msg} onChange={e=>setMsg(e.target.value)} />
              <button onClick={send} disabled={sending||!msg.trim()} style={{ width:"100%", background:"#fff", border:"1.5px solid #1a1a1a", color:"#1a1a1a", borderRadius:8, padding:"10px", fontSize:13, fontFamily:"'Geist',sans-serif", fontWeight:600, cursor:"pointer" }}>
                {sending?"Enviando…":"Enviar feedback"}
              </button>
            </>
          )}
        </div>
      )}
    </>
  );
}
